import React from 'react'
import InputWithLabel from '../../../../../../components/inputWithLabel';
import check from '../../../../../../assets/images/svgs/check.svg'
import checkRound from '../../../../../../assets/images/svgs/checkRound.svg'

const UnitText = ({ data, handleAnswer, answers }) => {

    const selectedAns = answers?.[data?.refCode];
    const selectedOption = selectedAns?.split(" + ")[0] ?? "";
    const inputText = selectedAns?.split(" + ")[1] ?? "";

    const answersArray = [
        {
            value: "sq ft",
        },
        {
            value: "sqm"
        }
    ]

    const handleOptionSelect = (value) => {
        handleAnswer(`${value} + ${inputText ?? ""}`);
    };

    const handleChangeInput = (e) => {
        handleAnswer(`${selectedOption} + ${e?.target?.value}`);
    }

    return (
        <>
            <div className="options">
                <div className="single__choice">
                    {answersArray?.map((v, i) => {
                        return <button onClick={() => handleOptionSelect(v?.value)} key={i}>
                            <div>
                                <img className='check__box' src={selectedOption === v?.value ? check : checkRound} alt='check_box' />
                            </div>
                            <div>
                                {v?.value}
                            </div>
                        </button>
                    })}
                </div>
                <div className=' w-100'>
                    <InputWithLabel requried type="number" value={Number(inputText) || ''} onChange={handleChangeInput} labelFontWeight="600" labelFont={11} inputFont={18} label={"Enter Value"} />
                </div>
            </div>
        </>
    )
}

export default UnitText;